<h1 mat-dialog-title>{{ 'succeed-activation.title' | translate }}</h1>
<div mat-dialog-content>
  @if (!data.voucherGroup.delaySend && !data.voucherGroup.dontSendUponActivation) {
    <div>
      {{ 'succeed-activation.info' | translate }}
    </div>
  }
  @if (data.voucherGroup.delaySend) {
    <div>
      {{ 'succeed-activation.info_delay' | translate }}
    </div>
  }
  @if (data.voucherGroup.dontSendUponActivation) {
    <div>
      {{ 'succeed-activation.info_not_sending' | translate }}
    </div>
  }
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close onClick="location.reload();">
    {{ 'succeed-activation.done' | translate }}
  </button>
</mat-dialog-actions>
